import Vue from "vue";
import VueRouter from "vue-router";
import { constantRouterMap,asyncRouterMap } from '@/config/router.config'
Vue.use(VueRouter);

// const routes = [
//   {
//     path: "/operationMaintenance1/logs",
//     name: "loperationMaintenance1Logs",
//     component: () => import("@/views/user/Login.vue"),
//     meta: {
//       title: "系统日志",
//       isAuth: false,
//     }
//   }
// ];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes:constantRouterMap,
});

// console.log('router111',router);

// 定义一个resetRouter 方法，在退出登录后或token过期后 需要重新登录时，调用即可
export function resetRouter() {
  const newRouter = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes:constantRouterMap,
  });
  router.matcher = newRouter.matcher;
}

export default router;
